import { render } from "./TopContributors.vue?vue&type=template&id=00a92c1e&scoped=true"
import script from "./TopContributors.vue?vue&type=script&lang=js"
export * from "./TopContributors.vue?vue&type=script&lang=js"

import "./TopContributors.vue?vue&type=style&index=0&id=00a92c1e&scoped=true&lang=css"

import exportComponent from "/home/acartia-ops/acartia/src/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a92c1e"]])

export default __exports__